import Products from 'merchandise-lib/constants/Product';
import { useProductDetailsForArray } from '../product/useProductDetails';
import { useIsInAppAuth } from '../user/useUserInfo';
import { useHubSpotCreditsPageRedirect } from './useHubSpotCreditsPageRedirect';

/**
 * This hook is used to determine if the HubSpot Credits product experience should be shown.
 */
export const useHubSpotCredits = () => {
  var _productDetails$produ;
  const isInAppAuth = useIsInAppAuth();
  const shouldRedirect = useHubSpotCreditsPageRedirect();
  const {
    productDetails,
    loading,
    error
  } = useProductDetailsForArray({
    productApiNames: [Products.HUBSPOT_CREDITS_COMMITTED, Products.HUBSPOT_CREDITS_COMMITTED_OVERAGE]
  });
  const hasHubSpotCreditsSkus = Object.keys((_productDetails$produ = productDetails === null || productDetails === void 0 ? void 0 : productDetails.productsByName) !== null && _productDetails$produ !== void 0 ? _productDetails$produ : {}).length > 0;
  return {
    showHubSpotCredits: isInAppAuth && hasHubSpotCreditsSkus && !shouldRedirect,
    loading,
    error
  };
};